import type { AnalyticsProperties, AnalyticsValue } from '../../types';

type FlattenedPostHogProperties = Record<string, AnalyticsValue>;

const isPlainObject = (
  value: AnalyticsValue,
): value is Record<string, AnalyticsValue> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const flattenPostHogProperties = (
  input: AnalyticsProperties,
  prefix = '',
): FlattenedPostHogProperties => {
  const output: FlattenedPostHogProperties = {};

  Object.entries(input).forEach(([key, value]) => {
    const nextKey = prefix ? `${prefix}_${key}` : key;

    if (isPlainObject(value)) {
      Object.assign(output, flattenPostHogProperties(value, nextKey));
      return;
    }

    if (value !== undefined) {
      output[nextKey] = value;
    }
  });

  return output;
};
